import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import React from 'react'

const OpenGraph = ({
  head: {
    CanonicalUrl,
    Description,
    MetaDescription,
    PageTitle,
    OGDescription,
    OGImage,
    OGTitle,
    OGUrl
  }
}) => {
  Description = Description || MetaDescription || OGDescription
  PageTitle =
    PageTitle ||
    OGTitle ||
    'High School Apparel, College Fan Gear, Sports Jerseys | Prep Sportswear'
  CanonicalUrl = CanonicalUrl || OGUrl

  return (
    <Helmet>
      <title>{PageTitle}</title>
      <meta name="description" content={Description} />
      <meta property="og:title" content={PageTitle} />
      <meta property="og:description" content={Description} />
      <meta property="og:image" content={OGImage} />
      <meta property="og:url" content={CanonicalUrl} />
      <link rel="canonical" href={CanonicalUrl} />
    </Helmet>
  )
}

OpenGraph.propTypes = {
  head: PropTypes.shape({
    CanonicalUrl: PropTypes.string,
    Description: PropTypes.string,
    MetaDescription: PropTypes.string,
    PageTitle: PropTypes.string,
    OGDescription: PropTypes.string,
    OGImage: PropTypes.string,
    OGTitle: PropTypes.string,
    OGUrl: PropTypes.string
  }).isRequired
}

export default OpenGraph
